import useSubscriptionProducts from './useSubscriptionProducts';
import { ultraCollarId } from '../types';
import { formattedCentsToDollars } from '../lib/util';

export type MembershipChoice = '1y' | '2y';

export interface MembershipOption {
  id: MembershipChoice;
  renewalMonths: number;
  priceInCents: number;
  label: string;
  price: string;
  perWeek: string;
  sku: string;
}

/**
 * Memberships offered when purchasing Ultra for a new dog (no existing subscription to extend).
 * Filters the Ultra-purchasable subscription catalog down to the 1-year and 2-year prepaid plans
 * and adapts each into the shape the confirmation modal renders.
 */
export default function useNewDogUltraMemberships(): MembershipOption[] {
  return useSubscriptionProducts(ultraCollarId)
    .filter((s) => !s.thirdParty)
    .filter((s) => s.renewalMonths === 12 || s.renewalMonths === 24)
    .map<MembershipOption>((s) => ({
      id: s.renewalMonths === 12 ? '1y' : '2y',
      renewalMonths: s.renewalMonths,
      priceInCents: s.pricingInCents.USD,
      label: s.renewalMonths === 12 ? '1 year membership' : '2 year membership',
      price: formattedCentsToDollars(s.pricingInCents.USD),
      perWeek: `Equal to $${(s.pricingInCents.USD / ((s.renewalMonths * 52) / 12) / 100).toFixed(2)}/week`,
      sku: s.sku,
    }));
}
